module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"support_ticket_address":{"destination_address":"Endereço de destino"}},"en":{"support_ticket_address":{"destination_address":"Destination address"}}}')
  delete Component.options._Ctor
}
